import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.space.Report.Id,
    graphql.schema.SpaceReportId
  >({
    [ents.extra.space.Report.Id.AccountList]:
      graphql.schema.SpaceReportId.AccountList,
    [ents.extra.space.Report.Id.DataExport]:
      graphql.schema.SpaceReportId.DataExport,
    [ents.extra.space.Report.Id.EmployeeList]:
      graphql.schema.SpaceReportId.EmployeeList,
    [ents.extra.space.Report.Id.RoomLinks]:
      graphql.schema.SpaceReportId.RoomLinks,
    [ents.extra.space.Report.Id.RoomSupportingInformation]:
      graphql.schema.SpaceReportId.RoomSupportingInformation,
    [ents.extra.space.Report.Id.RoomsByAccount]:
      graphql.schema.SpaceReportId.RoomsByAccount,
    [ents.extra.space.Report.Id.RoomsByOccupant]:
      graphql.schema.SpaceReportId.RoomsByOccupant,
    [ents.extra.space.Report.Id.RoomsByResponsiblePerson]:
      graphql.schema.SpaceReportId.RoomsByResponsiblePerson,
    [ents.extra.space.Report.Id.SpaceSalaryComparison]:
      graphql.schema.SpaceReportId.SpaceSalaryComparison,
    [ents.extra.space.Report.Id.UnassignedSponsoredAccounts]:
      graphql.schema.SpaceReportId.UnassignedSponsoredAccounts,
    [ents.extra.space.Report.Id.UnassignedSponsoredPeople]:
      graphql.schema.SpaceReportId.UnassignedSponsoredPeople,
    [ents.extra.space.Report.Id.ProgressByOrganization]:
      graphql.schema.SpaceReportId.ProgressByOrganization,
    [ents.extra.space.Report.Id.UnclaimedRooms]:
      graphql.schema.SpaceReportId.UnclaimedRooms,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.SpaceReportId,
    ents.extra.space.Report.Id
  >({
    [graphql.schema.SpaceReportId.AccountList]:
      ents.extra.space.Report.Id.AccountList,
    [graphql.schema.SpaceReportId.DataExport]:
      ents.extra.space.Report.Id.DataExport,
    [graphql.schema.SpaceReportId.EmployeeList]:
      ents.extra.space.Report.Id.EmployeeList,
    [graphql.schema.SpaceReportId.RoomLinks]:
      ents.extra.space.Report.Id.RoomLinks,
    [graphql.schema.SpaceReportId.RoomSupportingInformation]:
      ents.extra.space.Report.Id.RoomSupportingInformation,
    [graphql.schema.SpaceReportId.RoomsByAccount]:
      ents.extra.space.Report.Id.RoomsByAccount,
    [graphql.schema.SpaceReportId.RoomsByOccupant]:
      ents.extra.space.Report.Id.RoomsByOccupant,
    [graphql.schema.SpaceReportId.RoomsByResponsiblePerson]:
      ents.extra.space.Report.Id.RoomsByResponsiblePerson,
    [graphql.schema.SpaceReportId.SpaceSalaryComparison]:
      ents.extra.space.Report.Id.SpaceSalaryComparison,
    [graphql.schema.SpaceReportId.UnassignedSponsoredAccounts]:
      ents.extra.space.Report.Id.UnassignedSponsoredAccounts,
    [graphql.schema.SpaceReportId.UnassignedSponsoredPeople]:
      ents.extra.space.Report.Id.UnassignedSponsoredPeople,
    [graphql.schema.SpaceReportId.ProgressByOrganization]:
      ents.extra.space.Report.Id.ProgressByOrganization,
    [graphql.schema.SpaceReportId.UnclaimedRooms]:
      ents.extra.space.Report.Id.UnclaimedRooms,
  }),
)
